import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=09163289&scoped=true&lang=pug&"
import script from "./DeleteModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&id=09163289&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09163289",
  null
  
)

export default component.exports